import {
  EVENT_LOGGER_CREATE_EVENTS,
  EVENT_LOGGER_GET_EVENTS,
} from "@shared/services/tour/urls/dashboard-urls.ts";
import eventLoggerGetEvents from "@shared/services/tour/mockedApis/eventLogger/eventLoggerGetEvents.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import genericEmptyResponse from "@shared/services/tour/mockedApis/generic/genericEmptyResponse.ts";

export default {
  [EVENT_LOGGER_GET_EVENTS]: () => eventLoggerGetEvents(),
  [EVENT_LOGGER_CREATE_EVENTS]: () => genericEmptyResponse(),
} satisfies TourUrlMapping;
